import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { AuthConfig } from 'angular-oauth2-oidc';
import { WindowService } from '@nx-customer-apps/shared/services';
import { environment } from '../../../environments/environment';

declare function require(moduleName: string): any;

const { versions: appVersions } = require('../../../../../../package.json');

// ignoring coverage for that class
/* istanbul ignore next */
@Injectable({
    providedIn: 'root'
})
export class EnvironmentService {
    constructor(private windowService: WindowService) {}

    public get name(): string {
        return environment.environment;
    }

    public get version(): string {
        return appVersions['planning-tools-config'];
    }

    public get baseUrl(): string {
        return environment.baseUrl;
    }

    public get userResultUrl(): string {
        return environment.userResultUrl;
    }

    public get flowEditorUrl(): string {
        return environment.apiPlanningProjectsConfig.apiBaseUrl + '/flow-editor';
    }

    public get production(): boolean {
        return environment.production;
    }

    public get applicationName(): string {
        return environment.applicationName;
    }

    public get authConfig(): AuthConfig {
        return environment.authConfig;
    }

    public get registerUrl(): string {
        let params = new HttpParams();
        params = params.append('hideNoCompanyNumberOption', 'true');
        if (environment.authConfig.redirectUri) {
            params = params.append('redirect', environment.authConfig.redirectUri);
        }
        return `${environment.accountAppUrl}/register?${params.toString()}`;
    }

    public get apiKey(): string {
        return environment.apiKey;
    }
}
